import config from "../config/config";

const path = (route) => `${config.BaseURL}${route}`;

export const _apiUrls = {
  userLogin: path("/user/login"),
  changePassword: path("/user/changePassword"),

  // User Management ----------------------------
  getUser: path("/user/getUser"),
  getUserReport: path("/user/getUserReport"),
  
  createUser: path("/user/createUser"),
  deleteUser: path("/user/deleteUser"),
  updateUser: path("/user/updateUser"),
  forgotPassword: path("/user/forgot-password"),
  resetpassword: path("/user/reset-password"),
  contactUs: path("/contactus/getContactUs"),
  dashboardApiCounts: path("/user/dashboard-count"),

  backgroundColor: path("/backgroundColor/get"),
  backgroundColorAdd: path("/backgroundColor/add"),
  backgroundColorDelete: path("/backgroundColor/delete"),

  // Catgegories ----------------------------
  getCategory: path("/category/getCategory"),
  addCategory: path("/category/addCategory"),
  updateCategory: path("/category/updateCategory"),
  deleteCategory: path("/category/deleteCategory"),
  getCategoryReport: path("/category/getCategoryReport"),


  // Notifications ----------------------------
  getNotification: path("/notification/getNotification"),
  getNotificationReport: path("/notification/getNotificationReport"),
  addNotification: path("/notification/addNotification"),
  updateNotification: path("/notification/updateNotification"),
  deleteNotification: path("/notification/deletNotification"),

  filterUser: path("/user/filter-user"),
  fetchCountry: path("/country/fetchCountry"),
  filterNotification: path("/notification/filter-Notification"),

  purchaseHistory: path("/purchaseHistory/get-purchase-stats"),
  getAdmin: path("/user/getAdmin"),
  updateAdmin: path("/user/updateAdmin"),
  createAdmin: path("/user/createAdmin"),
  updateAdmin: path("/user/updateAdmin"),
  setRoles: path("/user/createAdminRole"),

  getAllAdmins: path("/user/getAllAdmin"),

  

  
};
